<template>
    <v-dialog v-model="showModal" width="500">
        <v-card>
            <v-card-text>
                {{ 'Pickup was activated. Please note that not all items of your order can be picked up by yourself.' | translation }}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="primary"
                    @click.stop="showModal = false"
                >
                    {{ 'shut down' | translation }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'PartlyPickupModal',
        props: [
            'value',
        ],
        computed: {
            showModal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        },
    }
</script>
